import React from "react";
import { formatInstantDateShortTr, yearInAppTz } from "../../../utils/appTime";

export default function PrivacyPolicy() {
  const companyName = "Rovion Teknoloji";
  const website = "https://rovion.io";
  const email = "info@rovion.io";

  const today = new Date();
  const formattedDate = formatInstantDateShortTr(today);
  const year = yearInAppTz(today);

  return (
    <div style={styles.page}>
      {/* Top Banner */}
      <div style={styles.topBanner}>
        <h1 style={styles.bannerTitle}>Gizlilik Politikası</h1>
      </div>

      {/* Content */}
      <div style={styles.container}>
        <p>
          Bu Gizlilik Politikası, <strong>{companyName}</strong> tarafından
          işletilen ve sunulan hizmetler kapsamında kişisel verilerin nasıl
          toplandığını, kullanıldığını ve korunduğunu açıklamaktadır.
        </p>

        <SectionTitle>1. Toplanan Bilgiler</SectionTitle>
        <p>Aşağıdaki türde bilgiler toplanabilir:</p>
        <ul>
          <li>Ad, soyad</li>
          <li>E-posta adresi</li>
          <li>Telefon numarası</li>
          <li>Firma bilgileri</li>
        </ul>

        <SectionTitle>2. Bilgilerin Kullanımı</SectionTitle>
        <p>Toplanan bilgiler şu amaçlarla kullanılabilir:</p>
        <ul>
          <li>Hizmet sunmak ve destek sağlamak</li>
          <li>Teklif ve demo taleplerini değerlendirmek</li>
          <li>Yasal yükümlülükleri yerine getirmek</li>
          <li>Hizmet kalitesini artırmak</li>
        </ul>

        <SectionTitle>3. Bilgi Güvenliği</SectionTitle>
        <p>
          {companyName}, kişisel verilerin yetkisiz erişim, kayıp veya kötüye
          kullanımına karşı korunması için gerekli teknik ve idari önlemleri
          almaktadır.
        </p>

        <SectionTitle>4. Üçüncü Taraflarla Paylaşım</SectionTitle>
        <p>
          Kişisel veriler, yasal zorunluluklar dışında üçüncü kişilerle
          paylaşılmaz.
        </p>

        <SectionTitle>5. KVKK Kapsamındaki Haklarınız</SectionTitle>
        <p>
          6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında aşağıdaki
          haklara sahipsiniz:
        </p>
        <ul>
          <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
          <li>İşlenmişse buna ilişkin bilgi talep etme</li>
          <li>Verilerin düzeltilmesini veya silinmesini isteme</li>
          <li>İşlemeye itiraz etme</li>
        </ul>

        <SectionTitle>6. İletişim</SectionTitle>
        <p>
          Gizlilik politikamız ile ilgili sorularınız için bizimle iletişime
          geçebilirsiniz:
        </p>
        <p>
          <strong>E-posta:</strong> {email}
        </p>

        <p style={styles.lastUpdate}>Son Güncelleme: {formattedDate}</p>
      </div>

      {/* Footer */}
      <div style={styles.footer}>
        © {year} {companyName} - Tüm Hakları Saklıdır.
      </div>
    </div>
  );
}

function SectionTitle({ children }) {
  return <h3 style={styles.sectionTitle}>{children}</h3>;
}

const styles = {
  page: {
    fontFamily: "'Inter', sans-serif",
    backgroundColor: "#f4f7fb",
    color: "#1e293b",
    lineHeight: "1.7",
    minHeight: "100vh",
    overflowY: "auto",
    height: "100vh",
  },
  topBanner: {
    backgroundColor: "#00b4f3",
    padding: "60px 20px",
    textAlign: "center",
    color: "white",
  },
  bannerTitle: {
    fontSize: "36px",
    fontWeight: 700,
  },
  container: {
    maxWidth: "1000px",
    margin: "-40px auto 60px auto",
    backgroundColor: "white",
    padding: "50px",
    borderRadius: "14px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
  },
  sectionTitle: {
    marginTop: "35px",
    marginBottom: "12px",
    color: "#00b4f3",
    fontSize: "18px",
  },
  lastUpdate: {
    marginTop: "40px",
    fontSize: "14px",
    color: "#94a3b8",
  },
  footer: {
    textAlign: "center",
    padding: "25px",
    fontSize: "14px",
    color: "#64748b",
  },
};
